var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabeledSelect',{attrs:{"label":_vm.t('monitoring.clusterType.label'),"placeholder":_vm.t('monitoring.clusterType.placeholder'),"localized-label":true,"options":_vm.clusterTypes},model:{value:(_vm.clusterType),callback:function ($$v) {_vm.clusterType=$$v},expression:"clusterType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }